export const ANIMALS_CHECKBOX_INDEX = 0;
export const ANIMALS_NAME_INDEX = 1;
export const ANIMALS_QUANTITY_INDEX = 2;
export const ANIMALS_DATE_INDEX = 3;
export const ANIMALS_HUNTER_INDEX = 4;
export const ANIMALS_COLLECTION_CENTRE_INDEX = 5;
export const ANIMALS_NUMBER_MP_INDEX = 6;
export const ANIMALS_DISTRICT_INDEX = 7;
export const ANIMALS_WEIGHT_INDEX = 8;
export const ANIMALS_IDENTIFIER_INDEX = 9;
export const ANIMALS_IDENTIFIER_DISTRICT_VETERINARIAN_INDEX = 10;
export const ANIMALS_IDENTIFIER_DIRECT_SALE_INDEX = 11;
export const ANIMALS_ACTIONS_INDEX = 12;

export const PRICE_LIST_REGULAR = 1;
export const PRICE_LIST_FLAT_RATE = 2;

export const ITEMS_NO_INDEX = 0;
export const ITEMS_NAME_INDEX = 1;
export const ITEMS_UNIT_INDEX = 2;
export const ITEMS_QUANTITY_INDEX = 3;
export const ITEMS_PRICE_INDEX = 4;
export const ITEMS_QUALITY_INDEX = 6;
export const ITEMS_ACTION_INDEX = 6;

export const ITEM_TYPE_ITEM = 'app\\models\\Item';
export const ITEM_TYPE_BOOK_RECORD_ANIMAL = 'app\\models\\BookRecordAnimal';
export const ITEM_TYPE_COLLECTIVE_HUNTING_ANIMAL = 'app\\models\\CollectiveHuntingAnimal';
export const ITEM_TYPE_GROUP_HUNTING_ANIMAL = 'app\\models\\GroupHuntingAnimal';

export const ITEMS_ITEM_NAME_INDEX = 0;
export const ITEMS_ITEM_UNIT_INDEX = 1;
export const ITEMS_ITEM_PRICE_INDEX = 2;
export const ITEMS_ITEM_VAT_INDEX = 3;
export const ITEMS_ITEM_CODE_INDEX = 4;
export const ITEMS_ITEM_QUANTITY_INDEX = 5;
export const ITEMS_ITEM_ACTION_INDEX = 6;

export const ENTITIES_NAME_INDEX = 0;
export const ENTITIES_ADDRESS_INDEX = 1;
export const ENTITIES_ACTION_INDEX = 2;

export const ENTITY_PRICE_LIST_NAME_INDEX = 0;
export const ENTITY_PRICE_LIST_PRICE_1_CLASS_INDEX = 1;
export const ENTITY_PRICE_LIST_PRICE_2_CLASS_INDEX = 2;
export const ENTITY_PRICE_LIST_PRICE_BEYOND_INDEX = 3;
export const ENTITY_PRICE_LIST_FLAT_RATE_INDEX = 4;
